const questionList = () => import('@/pages/content/question/index.vue');
const questionForm = () => import('@/pages/content/question/form.vue');

export default [{
    path: '/content/question',
    component: questionList,
    meta: [{
        name: '内容管理'
    },
    {
        name: '常见问题管理',
        activeRoute: '/content/question'
    }]
}, {
    path: '/content/question/form',
    component: questionForm,
    meta: [{
        name: '内容管理'
    }, {
        name: '常见问题管理',
        url: '/content/question'
    }, {
        name: '新增/编辑',
        activeRoute: '/content/question'
    }]
}];